<template>
  <div class="insights-navigation-list">
    <div
      v-if="!isReady"
      key="initial"
    >
      <InsightsNavigationListCardLoading
        v-for="i in defaultItemsLoading"
        :key="i"
      />
    </div>
    <template v-else>
      <div
        v-if="items.length"
        :id="`${type}-scroll-container`"
        class="insights-navigation-list-items"
        :style="scrollStyle"
      >
        <InsightsNavigationListCard
          v-for="item in slicedItems"
          :key="item.id"
          :item="item"
          :type="type"
          :active="isActiveTeam(item.id)"
        />
        <template v-if="additionalLoadingItems > 0">
          <InsightsNavigationListCardLoading
            v-for="i in additionalLoadingItems"
            :key="`additional-${i}`"
          />
        </template>
        <div
          v-show="showLoadMore"
          :class="`load-more ${type}-load-more`"
        />
      </div>
      <InsightsNavigationListEmpty
        v-else
        :type="type"
        :item-id="currentDashboardId"
        :individual="isIndividualTeamDashboard"
      />
    </template>
  </div>
</template>

<script>
import InsightsNavigationListCard from '~/components/insights/InsightsNavigationListCard.vue';
import InsightsNavigationListCardLoading from '~/components/insights/InsightsNavigationListCardLoading.vue';
import InsightsNavigationListEmpty from '~/components/insights/InsightsNavigationListEmpty.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'InsightsNavigationList',
  components: {
    InsightsNavigationListCard,
    InsightsNavigationListCardLoading,
    InsightsNavigationListEmpty,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    teamId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    itemsToShow: {},
    additionalLoadingItems: 0,
    observers: {},
    loadingMore: false,
    defaultItemsToShow: 10,
    defaultItemsLoading: 9,
  }),
  computed: {
    ...mapGetters(['loadingUsers', 'currentDashboardId', 'isIndividualTeamDashboard']),
    ...mapState(['hubspot_enabled']),
    scrollStyle() {
      return { paddingBottom: this.type === 'user' && this.hubspot_enabled ? '80px' : null };
    },
    isReady() {
      return !this.loadingUsers?.initial ?? false;
    },
    toShow() {
      return this.itemsToShow[this.type] || 0;
    },
    slicedItems() {
      return this.items.slice(0, this.itemsToShow[this.type] || this.defaultItemsToShow);
    },
    showLoadMore() {
      return this.isReady && !this.loadingMore && this.items.length > this.slicedItems.length;
    },
  },
  mounted() {
    this.addObserver();
  },
  updated() {
    this.addObserver();
  },
  beforeUnmount() {
    if (this.observers[this.type]) {
      this.observers[this.type].disconnect();
    }
  },
  methods: {
    addObserver() {
      this.observers[this.type] = new IntersectionObserver(this.handleIntersect, { root: null, threshold: 0.5 });

      const target = document.querySelector(`.${this.type}-load-more`);

      if (target) {
        this.observers[this.type].observe(target);
      }
    },
    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.loadingMore && this.items.length > this.toShow) {
          this.additionalLoadingItems = 5;
          this.loadingMore = true;
          setTimeout(() => {
            this.additionalLoadingItems = 0;
            this.itemsToShow = { ...this.itemsToShow, [this.type]: this.toShow + 20 };
            this.loadingMore = false;
          }, 500);
        }
      });
    },
    isActiveTeam(id) {
      return this.type === 'team' && Number(this.teamId) === id;
    },
  },
};
</script>
